import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const retailChainBrandDraftStyles = ({ theme }) => ({
    position: 'fixed',
    inset: 0,
    zIndex: theme.zIndex.drawer + 1,
    '& .retail-chain-brand-draft__backdrop': {
        position: 'absolute',
        inset: 0,
        background: 'rgba(247, 247, 247, 0.85)',
    },
    '& .MuiPaper-root.custom-dialog-right': {
        zIndex: 1,
        overflowY: 'auto !important',
        maxHeight: '100%',
    },
});

export const retailChainSectionStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    width: '100%',
    [`@media (max-width: ${breakpoints.values.md}px)`]: {
        gap: '24px',
    },
    '& .MuiTypography-h5': {
        marginBottom: 0,
        fontSize: '22px',
        lineHeight: '28px',
    },
    '& .MuiFormHelperText-root': {
        display: 'none',
        '&.Mui-error': {
            display: 'block',
        },
    },
};
